import './ShareResults.scss';

import { Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import useToast from '@hooks/useToast';
import ContentContainer from '@layouts/container/ContentContainer';
import { shareResults } from '@store/actions';

import { ShareResultsFormValues } from './components/ShareResultsForm/ShareResults.types';
import ShareResultsForm from './components/ShareResultsForm/ShareResultsForm';
import SharingHistory from './components/SharingHistory/SharingHistory';

const validationSchema = Yup.object({
  recipient_email: Yup.string().email('Invalid email').required('Required'),
  confirm_email: Yup.string()
    .email('Invalid email')
    .required('Confirm Email is required')
    .test('email-match', 'Emails do not match', function (value) {
      return value === this.resolve(Yup.ref('recipient_email'));
    }),
  recipient_name: Yup.string(),
  agree_to_share: Yup.boolean().oneOf([true], 'You must agree to share your results').required('Required'),
});

const ShareResults = () => {
  const { addToast } = useToast();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const initialValues: ShareResultsFormValues = {
    recipient_email: '',
    confirm_email: '',
    recipient_name: '',
    agree_to_share: false,
  };

  const onSubmit = async (values: ShareResultsFormValues, { resetForm }: { resetForm: () => void }) => {
    try {
      // Map form values to API request format
      const response = await shareResults({
        email: values.recipient_email,
        ...(values.recipient_name && { name: values.recipient_name }),
      });

      // Show success toast
      addToast({
        headerTitle: 'Success',
        content: response.message || 'Your results have been shared successfully.',
        variant: 'success',
      });

      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      resetForm();
      setRefreshTrigger(prev => prev + 1);
    } catch (error) {
      // Error toast is handled automatically by axios interceptor
      console.error('Error sharing results:', error);
    }
  };

  return (
    <ContentContainer containerClass='share-results-content bg-white pt-5 pb-5'>
      <div className='row'>
        <div className='col-12 col-lg-8 mb-6 mb-lg-0 share-results-left'>
          <Formik<ShareResultsFormValues>
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            <ShareResultsForm />
          </Formik>
        </div>
        <div className='col-12 col-lg-4 share-results-right'>
          <SharingHistory refreshTrigger={refreshTrigger} />
        </div>
      </div>
    </ContentContainer>
  );
};

export default ShareResults;
